import {get as _get} from 'lodash';

import initialState from '../initialstate';

import {
	GET_RECEIVED_INSTRUCTIONS,
	PUT_RECEIVED_INSTRUCTIONS,
	GET_EARLIER_SNAPSHOT,
	RESET_EARLIER_SNAPSHOT,
	GET_GROUP_VERSIONS_RECEIVED_INSTRUCTIONS,
	GET_GROUP_DOCUMENTS_INSTRUCTIONS
} from '../../actions/actiontypes';

import {HttpStatusCodes} from '../../util/uiconstants';
import normalizeReceivedInstructions from './normalizeReceivedInstructions';
import normalizeEarlierOptions from './normalizeEarlierOptions';

export default function ReceiveInstructionsReducer(state = initialState.receiveIntructions, action) {
	switch (action.type) {
		case GET_RECEIVED_INSTRUCTIONS: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const data = _get(action, 'responseObj.data', []);
				return {...state, received: normalizeReceivedInstructions(data)};
			}
			return state;
		}
		case GET_GROUP_VERSIONS_RECEIVED_INSTRUCTIONS: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const data = _get(action, 'responseObj.data', []);
				return {...state, earlierOptions: normalizeEarlierOptions(data)};
			}
			return state;
		}
		case GET_GROUP_DOCUMENTS_INSTRUCTIONS: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const data = _get(action, 'responseObj.data', []);
				return {...state, received: normalizeReceivedInstructions(data)};
			}
			return state;
		}
		case PUT_RECEIVED_INSTRUCTIONS: {
			return state;
		}
		case GET_EARLIER_SNAPSHOT: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const data = _get(action, 'responseObj.data', []);
				return {...state, earlierSnapshot: normalizeReceivedInstructions(data)};
			}
			return state;
		}
		case RESET_EARLIER_SNAPSHOT: {
			return {...state, earlierSnapshot: null};
		}
		default:
			return state;
	}
}
